import createReactClass from "create-react-class";
import React from "react";
import Loader from "./loader";
import NecessariesItem from "./necessaries_item";
export default createReactClass({
  displayName: "Root",
  loadNotificationListFromServer() {
    this.setState({ loading: true });
    var companyId = (typeof this.props.companyId === 'undefined') ? null : this.props.companyId;
    $.ajax({
      url: "/api/notification/necessaries",
      data: {
        company_id: companyId,
      },
      dataType: "json",
      cache: false,
      success: function(data) {
        // var display = data.necessaries.length == 0 ? "block" : "block";
        this.setState({
          loading: false,
          necessariesList: data,
          uncheckedNotificationCount: 0,
        });
      }.bind(this),
      error: function() {
        this.setState({ loading: false });
      }.bind(this),
    });
  },
  // setIsCheckedToServer() {
  //   $.ajax({
  //     url: "/api/notification/necessaries_is_checked",
  //     dataType: "json",
  //     type: "POST",
  //     headers: {
  //       "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
  //     },
  //     cache: false,
  //     success: function() {}.bind(this),
  //     error: function() {}.bind(this),
  //   });
  // },
  getInitialState() {
    return {
      loading: true,
      necessariesList: { necessaries: [] },
    };
  },
  componentDidMount() {
    this.loadNotificationListFromServer();
    // this.setIsCheckedToServer();
  },
  render() {
    var necessariesTitleWidth = this.state.necessariesTitleWidth;
    var necessariesItems = this.state.necessariesList.necessaries && this.state.necessariesList.necessaries.length > 0  ? (
      this.state.necessariesList.necessaries.map(function(item) {
        return (
          <NecessariesItem
            necessariesItem={item}
            necessariesTitleWidth={necessariesTitleWidth}
            key={item.id}
          />
        );
      })
    ) : (
      <div className="pt-5" style={{filter: 'grayscale(100%)', textAlign: "center"}}>
        <img src="/favicon.ico" height="90px" style={{borderRadius: '50px'}} />
        <h6 className="text-gray text-fz-20px text-fw-bold pt-5">現在、やることリストはございません。</h6>
        <p className="text-gray text-fz-14px">ここでは、ご利用にあたり必ず対応いただく<br/>必要があることを表示しています。</p>
      </div>
    );
    var necessariesList = (
      <div style={{ padding: "0" }}>
        <div>
        {this.state.loading ? (
            <Loader isActive={this.state.loading} />
            ) : necessariesItems
          }
        </div>
      </div>
    );
    return <div>{necessariesList}</div>;
  },
});